(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-mega-panels"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const panels = document.querySelectorAll('.header-mega-menu');
    if (!panels.length) return;

    const header = document.querySelector('#header-component, .header, header-component');
    if (!header) return;

    const triggerMap = new Map();
    panels.forEach((panel) => {
      const trigger = panel.dataset.megaMenuTrigger;
      if (trigger) triggerMap.set(trigger, panel);
    });

    const menuLinks = header.querySelectorAll('.menu-list__link, .menu-list__item');
    const itemMap = new Map();

    menuLinks.forEach((link) => {
      const title = (link.textContent || '').trim().toLowerCase();
      if (triggerMap.has(title)) {
        const listItem = link.closest('.menu-list__list-item, li');
        if (listItem) {
          itemMap.set(listItem, triggerMap.get(title));
          listItem.dataset.customMegaMenu = 'true';
        }
      }
    });

    if (!itemMap.size) return;

    // Hide default theme submenu for items we control
    const styleEl = document.createElement('style');
    styleEl.textContent = `
      .menu-list__list-item[data-custom-mega-menu="true"] > .menu-list__submenu {
        display: none !important;
      }
    `;
    document.head.appendChild(styleEl);

    let activePanel = null;
    let hideTimer = null;

    const showPanel = (panel) => {
      clearTimeout(hideTimer);
      if (activePanel && activePanel !== panel) {
        activePanel.hidden = true;
      }
      panel.hidden = false;
      activePanel = panel;
    };

    const hidePanel = () => {
      hideTimer = setTimeout(() => {
        if (activePanel) {
          activePanel.hidden = true;
          activePanel = null;
        }
      }, 120);
    };

    itemMap.forEach((panel, listItem) => {
      listItem.addEventListener('mouseenter', () => showPanel(panel));
      listItem.addEventListener('mouseleave', hidePanel);
      listItem.addEventListener('focusin', () => showPanel(panel));
      listItem.addEventListener('focusout', (e) => {
        if (!listItem.contains(e.relatedTarget)) hidePanel();
      });

      panel.addEventListener('mouseenter', () => clearTimeout(hideTimer));
      panel.addEventListener('mouseleave', hidePanel);
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && activePanel) hidePanel();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
